import axios from 'axios';
import Toast from './services/Toast';
import Const from './config/const';
import { withApplication } from './services/PendingApplication';

const axiosInstance = axios.create({
  baseURL: Const.apiUrl, // Replace with your API URL
  timeout: 100000,
  headers: {
    'Content-Type': 'application/json',
  },
});
// Add a request interceptor to include the bearer token
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token'); // Replace 'token' with your actual key
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add a response interceptor to handle unauthorized responses
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if(error.response?.data?.message){
      Toast.error(error.response.data.message)
    }
    else if(error?.message){
      Toast.error(error.message);
    }
    if (error.response && error.response.status === 401) {
      // ?action=logout is a device-scoped logout handoff from a client app. A
      // 401 there just means the session is already gone: clear local state,
      // but do NOT redirect — the redirect below preserves the query string, so
      // it would reload ?action=logout and re-enter the logout branch forever.
      const isLogoutHandoff =
        new URLSearchParams(window.location.search).get('action') === 'logout';
      if (isLogoutHandoff) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        return Promise.reject(error);
      }
      // On the switch page, never redirect away — any 401 (auth/me, exchange-ott)
      // must not loop back to /switch and trigger a second exchange-ott call
      const onSwitchPage = window.location.pathname.includes('/switch');
      if (!onSwitchPage) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        // The session is gone, so the login page is the only useful
        // destination. Sending users to /home instead meant /home could do
        // nothing but bounce onward to "/", and that extra hop is what used to
        // drop the ?application= handoff on the floor. withApplication() also
        // restores the param if an earlier redirect already lost it.
        //
        // Never redirect while already on the login page: a wrong password is
        // also a 401, and reloading there would wipe what the user typed. The
        // login form reads the pending application from storage, so it does not
        // need the param back in the URL to hand off correctly.
        if(window.location.pathname != "/") {
          window.location.href = withApplication("/");
        }
      }
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
